import(/* webpackMode: "eager", webpackExports: ["PageViewTrigger"] */ "/vercel/path0/apps/hsiyc/components/page-view-trigger/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/hsiyc/components/tooltip/help-icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackingEventWrapper"] */ "/vercel/path0/apps/hsiyc/components/tracking-event-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/hsiyc/components/v2/vehicle-variants/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddToCompare"] */ "/vercel/path0/apps/hsiyc/components/vehicle-details/add-to-compare/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackButton"] */ "/vercel/path0/apps/hsiyc/components/vehicle-details/back-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmissionStars"] */ "/vercel/path0/apps/hsiyc/components/vehicle-details/efficiency-ratings/emission-stars/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.3.8_@babel+core@7.29.0_@playwright+test@1.63.0_@types+node@20.19.33_babel-plugi_c8594ccccec3230f9cc72e7911de307a/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.3.8_@babel+core@7.29.0_@playwright+test@1.63.0_@types+node@20.19.33_babel-plugi_c8594ccccec3230f9cc72e7911de307a/node_modules/next/dist/client/image-component.js");
